import type { IconDefinition } from '../index.tsx';

export const iconUnlock: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconUnlock',
  icon: [
    16,
    16,
    [],
    '',
    'M12.5 2C11.6716 2 11 2.67157 11 3.5V6H14V16H2V6H9V3.5C9 1.567 10.567 0 12.5 0C14.433 0 16 1.567 16 3.5V4H14V3.5C14 2.67157 13.3284 2 12.5 2ZM10 10H6V12H10V10Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
